module.exports = __webpack_public_path__ + "static/img/1837_phase_function_Paper_PointsHejduk_Prediction.9a86f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1837_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7QTI
// module chunks = 0